import { render, staticRenderFns } from "./SalePeople.vue?vue&type=template&id=7ccd3e18&"
import script from "./SalePeople.vue?vue&type=script&lang=js&"
export * from "./SalePeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports